import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { sanitizeQueryParam } from '@v2/lib';
import type { Instance } from '@v2/types';

interface UseInstanceNavigationResult {
  selectedInstanceId: string | null;
  handleSelectInstance: (instance: Instance) => void;
  handleClosePanel: () => void;
}

export const useInstanceNavigation = (): UseInstanceNavigationResult => {
  const history = useHistory();
  const location = useLocation();

  const selectedInstanceId = sanitizeQueryParam(
    new URLSearchParams(location.search).get('instanceId'),
  );

  const handleSelectInstance = useCallback(
    (instance: Instance) => {
      const params = new URLSearchParams(location.search);
      params.set('instanceId', instance.id);
      history.push({ search: params.toString() });
    },
    [history, location.search],
  );

  const handleClosePanel = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete('instanceId');
    history.push({ search: params.toString() });
  }, [history, location.search]);

  return { selectedInstanceId, handleSelectInstance, handleClosePanel };
};
